export const STATUS_DICTIONARY = {
  open: 'open',
  close:'close'
}